// Small in-memory cache for read-mostly public data (categories, category
// product listings) so navigating Category A -> B -> back to A doesn't
// re-fetch and re-render from a loading state every time.
//
// Deliberately NOT localStorage/IndexedDB: this only needs to survive
// while the SPA session is open, not across tabs or reloads, and a plain
// module-level Map is the simplest thing that does that.
//
// Freshness, not correctness, is what TTL buys here - admin edits (price,
// discount, hidden, new products) become visible within TTL_MS with zero
// invalidation wiring between the separately-authenticated admin app and
// the shop, which is the tradeoff this project needs: no stale-forever
// risk, no cross-app cache-busting machinery either.
const store = new Map();

export const DEFAULT_TTL_MS = 60_000;

export function getCached(key) {
  return store.get(key);
}

export function isFresh(entry, ttlMs = DEFAULT_TTL_MS) {
  return Boolean(entry) && Date.now() - entry.fetchedAt < ttlMs;
}

export function setCached(key, data) {
  store.set(key, { data, fetchedAt: Date.now() });
}
